import React from 'react';
import { MoreVertical } from 'lucide-react';

function formatRefDate(dateStr) {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split('-');
  if (!year || !month || !day) return dateStr;
  return `${day}/${month}/${year}`;
}

export default function Card({
  title,
  subtitle,
  children,
  className = '',
  action,
  onClick,
  refDate
}) {
  const formattedDate = formatRefDate(refDate);
  return (
    <div
      className={`
        bg-[var(--card)] border border-[var(--border)] rounded-xl p-6
        transform transition-all duration-300 hover:shadow-xl hover:-translate-y-1
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
      `}
      onClick={onClick}
    >
      {(title || subtitle || action || formattedDate) && (
        <div className="flex items-start justify-between mb-4">
          <div>
            {title && (
              <h3 className="text-lg font-semibold text-[var(--text)] mb-1">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="text-sm text-[var(--muted)]">
                {subtitle}
              </p>
            )}
          </div>
          <div className="flex items-center gap-2 flex-shrink-0 ml-3">
            {formattedDate && (
              <span className="text-[10px] font-mono font-semibold text-[var(--muted)] bg-[var(--accent-soft)] border border-[var(--border)] px-2 py-0.5 rounded-md">
                {formattedDate}
              </span>
            )}
            {action && (
              <button className="p-1 rounded-md hover:bg-[var(--accent-soft)] text-[var(--muted)] hover:text-[var(--text)] transition-colors">
                <MoreVertical size={18} />
              </button>
            )}
          </div>
        </div>
      )}
      {children}
    </div>
  );
}
